export const triggerHooks = {
  TOP: 0,
  MIDDLE: 0.5,
  BOTTOM: 1,
};
